import { render, staticRenderFns } from "./StringCell.vue?vue&type=template&id=238f2b91&"
import script from "./StringCell.vue?vue&type=script&lang=js&"
export * from "./StringCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports